import { render, staticRenderFns } from "./FormUploadTool.vue?vue&type=template&id=9ffb5626"
import script from "./FormUploadTool.vue?vue&type=script&lang=ts"
export * from "./FormUploadTool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports